module.exports = __webpack_public_path__ + "img/home_title.307df328.png";